import withConfigTransport from '../../services/config-transport/withConfigTransport'

import _VaColorIndicatort from './VaColorIndicator.vue'

export const VaColorIndicator = withConfigTransport(_VaColorIndicatort)
